// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// הוספנו את השורה הזו כדי לייבא את כלי ההתחברות:
import { getAuth, GoogleAuthProvider } from "firebase/auth";
// הוספנו את השורה הזו כדי לייבא את Firestore:
import { getFirestore } from "firebase/firestore";
// הוספנו את השורה הזו כדי לייבא את Storage:
import { getStorage } from "firebase/storage";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAK2cdAZsSvEVqvMaIbLBMKtEUOeWQ7_3Q",
  authDomain: "inorai.firebaseapp.com",
  projectId: "inorai",
  storageBucket: "inorai.firebasestorage.app",
  messagingSenderId: "602544022028",
  appId: "1:602544022028:web:b515abe97e24b3a590c429",
  measurementId: "G-C2EV66Z92F"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);

// הוספנו את החלק הזה - מייצאים את כלי ההתחברות כדי להשתמש בהם באתר
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();

// הוספנו את החלק הזה - מייצאים את בסיס הנתונים (Firestore)
export const db = getFirestore(app);

// הוספנו את החלק הזה - מייצאים את Storage
export const storage = getStorage(app);
